import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import React from 'react';
import { LayerGroup, MapContainer, TileLayer } from 'react-leaflet';

import CustomMarker from './CustomMarker';
import Key from './Key';

const US_GEOGRAPHIC_CENTER = L.latLng(39.8283, -98.5795);

const Map = ({ rows }) => {
  const colorMap = rows.reduce((acc, row) => {
    if (acc[row.company] || !row.marker_color) return acc;
    return { ...acc, [row.company]: row.marker_color };
  }, {});

  return (
    <>
      <Key colorMap={colorMap} />
      <MapContainer
        className="mb-32 h-[500px] w-full"
        center={US_GEOGRAPHIC_CENTER}
        scrollWheelZoom={false}
        zoom={4}
      >
        <TileLayer
          id="mapbox.light"
          attribution='Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>'
          url="https://api.mapbox.com/styles/v1/mikesullivan/ckokgdse6008i17pkxy2jkwlt/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoibWlrZXN1bGxpdmFuIiwiYSI6ImNrMWF6dWozYTAxcngzbnIwOTJrMmhvYmwifQ.ugZFinSO9_WHLPWiR4UV1Q"
        />
        <LayerGroup>
          {rows.map((row, index) => {
            if (!row.latitude || !row.longitude) return null;
            return (
              <CustomMarker
                key={index}
                company={row.company}
                count={row.number_of_chips}
                index={index}
                lat={Number(row.latitude)}
                location={row.location}
                long={Number(row.longitude)}
                markerColor={row.marker_color}
                markerSize={Number(row.marker_size)}
                status={row.status}
                type={row.type_of_chip}
              />
            );
          })}
        </LayerGroup>
      </MapContainer>
    </>
  );
};

export default Map;
